"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileLinks = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const menu_hooks_1 = require("../../shared/menu.hooks");
const enhanced_1 = require("../enhanced");
const Styled = styled_components_1.default.div `
	text-align: left;
	position: relative;
	top: 0;
	left: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	visibility: ${(p) => (p.menuOpen ? "visible" : "hidden")};
	&:hover {
		visibility: visible;
		> section {
			opacity: 1;
		}
	}
	display: block;
	overflow-y: auto;
	scrollbar-width: thin;
	max-height: calc(100vh - 52px - 66px);
	background: ${(p) => p.theme.palette.background.default};

	> section {
		min-height: 100%;
		opacity: ${(p) => (p.menuOpen ? 1 : 0)};
		transition: opacity 0.5s ${(p) => p.theme.easing};
	}
	.main-links {
		margin: 0;
		padding: 0;

		a {
			border-bottom: 1px solid ${(p) => p.theme.palette.border};
			&:last-child {
				border-bottom: none;
			}
			.h3 {
				margin: 0;
				font-size: 18px;
				${(p) => p.theme.breakpoints.down("xs")} {
					font-size: 14px;
				}
			}
		}

		&:last-child {
			border-right: none;
		}
	}
	a {
		white-space: nowrap;
		transition: 0.2s color ${(p) => p.theme.easing};
	}
	p {
		text-transform: none;
	}
	&& {
		.main-links {
			a {
				${(p) => p.theme.breakpoints.down("sm")} {
					padding: 10px 48px;
				}
				${(p) => p.theme.breakpoints.down("xs")} {
					padding: 10px 24px;
				}
			}
			a:hover {
				color: ${(p) => p.theme.palette.accent.text};
				text-decoration: none;
			}
		}
	}

	&.tablet {
		display: flex;
		justify-content: flex-start;
		align-items: stretch;
		a {
			padding: 0;

			.h3 {
				margin-bottom: 6px;
				font-size: 18px;
				line-height: 26px;
			}
		}
		.main-links {
			width: 50%;
			padding: 16px 0 16px 48px;
			a {
				border-bottom: none;
			}
		}
	}
`;
/**
 * Will split the links if greater than seven into 2 columns. Does not support more than 14 links
 */
const MobileLinks = ({ menuOpen, links = [], tablet, minHeight, locale, disableHrefTemplate, }) => {
    let first = links;
    let second = [];
    if (tablet && links.length > 5) {
        const cut = Math.ceil(links.length / 2);
        first = links.slice(0, cut);
        second = links.slice(cut, links.length);
    }
    //subtract back button height
    const mHeight = minHeight ? minHeight - 65 : 200;
    const closeMenus = (0, menu_hooks_1.useCloseAllMenus)();
    //we need to modify these mobile links to close the menus when clicked
    links.forEach((link) => {
        if (link && !link.__wrapped) {
            const prevHandler = link.onClick;
            const { localeHref } = (0, epic_games_nav_shared_1.getHrefWithLocale)(Object.assign(Object.assign({}, link), { locale }));
            link.onClick = (e) => {
                closeMenus();
                if (link.useCustomCallback) {
                    if (prevHandler && typeof prevHandler === "function") {
                        prevHandler(e);
                    }
                    else {
                        e.preventDefault();
                        (0, epic_games_nav_shared_1.navigateWithHref)(localeHref, locale);
                    }
                }
                else if (!link.useCustomCallback && prevHandler && typeof prevHandler === "function") {
                    prevHandler(e);
                }
            };
            link.__wrapped = true;
        }
    });
    return (react_1.default.createElement(Styled, { menuOpen: menuOpen, className: tablet ? "tablet" : "", style: { minHeight: mHeight } },
        react_1.default.createElement(enhanced_1.MainLinks, { links: first, locale: locale, disableHrefTemplate: disableHrefTemplate }),
        second.length ? react_1.default.createElement(enhanced_1.MainLinks, { links: second, locale: locale, disableHrefTemplate: disableHrefTemplate }) : ""));
};
exports.MobileLinks = MobileLinks;
//# sourceMappingURL=MobileLinks.js.map